import React, { useEffect } from 'react';

function useResizeObserver(ref) {
  const [size, setSize] = React.useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize({ width, height });
    });

    observer.observe(ref.current);
    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [ref]);

  return size;
}

export default useResizeObserver;
